<template>
  <BaseModal v-if="modalStore.successModal.toShow">
    <SuccessModal
      :progressLevel="modalStore.successModal.progressLevel"
      @animationComplete="hideSuccessModal"
    />
  </BaseModal>
  <BaseModal
    v-if="modalStore.actionModal.toShow"
    :modalOptions="modalStore.actionModal.options"
  >
    <ActionModal
      :modalOptions="modalStore.actionModal.options"
      @onPrimaryButtonClick="toggleActionModal(false)"
    />
  </BaseModal>

  <BaseModal
    v-if="modalStore.walletModal.toShow"
    :modalOptions="modalStore.walletModal.options"
  >
    <WalletModal
      :modalOptions="modalStore.walletModal.options"
      @onPrimaryButtonClick="hideWalletModal"
      @onSecondaryButtonClick="hideWalletModal"
    />
  </BaseModal>

  <BaseModal
    v-if="modalStore.formComponentModal.toShow"
    :modalOptions="modalStore.formComponentModal.options"
  >
    <FormComponentModal
      :modalOptions="modalStore.formComponentModal.options"
      @onPrimaryButtonClick="toggleFormComponentModal(false)"
    />
  </BaseModal>
</template>
<script setup>
import { useModalStore } from "@/stores/components/modalStore";

import useModalActions from "@/composables/store/modal/useModalActions";

import BaseModal from "@/components/ui/modals/BaseModal.vue";
import SuccessModal from "@/components/ui/modals/SuccessModal.vue";
import ActionModal from "@/components/ui/modals/ActionModal.vue";
import WalletModal from "@/components/ui/modals/WalletModal.vue";
import FormComponentModal from "@/components/ui/modals/FormComponentModal.vue";

const {
  toggleActionModal,
  hideSuccessModal,
  hideWalletModal,
  toggleFormComponentModal,
} = useModalActions();

const modalStore = useModalStore();
</script>
<style lang="scss"></style>
